import React from 'react'
import { Route, IndexRoute } from 'react-router'

import Container from './containers/Container'
import connectListContainer from '../shared/connectors/ListContainer'
import DetailsContainer from './containers/DetailsContainer'

import getPath from '../../shared/utils/getPath'

const museumRoutes = (
  <Route
    component={Container}
    key="museum-routes"
    path={getPath('frontend', 'museum')}
  >
    <IndexRoute component={connectListContainer('museum')} />
    <Route
      path={getPath('frontend', 'museum', ':id')}
      component={DetailsContainer}
    />
  </Route>
)

export default museumRoutes



// WEBPACK FOOTER //
// ./src/frontend/museum/routes.js